/**
 * The StoryVariables object provides static functions to get the variable names for
 * the variables that the StoryFrameworkPlayer uses. All its functions are static and
 * this class is only meant to make sure that variable name conventions are easy to change.
 * All applications and games that make use of the variable names should use the functions 
 * in this class for the variable naming and NOT implement the string constructing by itself.
 **/
const StoryVariables = {};
export default StoryVariables;

/**
 * Get the variable name for an unlock of a StoryNode
 * @param {StoryNode} storyNode
 * @returns {String}
 */
StoryVariables.storyNodeUnlockedVariable = function(storyNode) {
    return "storynode" + storyNode.id + "_unlocked";
};
/**
 * Get the variable name for an available of a StoryNode
 * @param {StoryNode} storyNode
 * @returns {String}
 **/
StoryVariables.storyNodeAvailableVariable = function(storyNode) {
    return "storynode" + storyNode.id + "_available";
};
/**
 * Get the variable name for a complete of a StoryNode
 * @param {StoryNode} storyNode
 * @returns {String}
 **/
StoryVariables.storyNodeCompletedVariable = function(storyNode) {
    return "storynode" + storyNode.id + "_completed";
};
/**
 * Get the variable name for an unlock of a StoryArc
 * @param {StoryArc} storyArc
 * @returns {String}
 **/
StoryVariables.storyArcUnlockedVariable = function(storyArc) {
    return "storyarc" + storyArc.id + "_unlocked";
};
/**
 * Get the variable name for an available of a StoryArc
 * @param {StoryArc} storyArc
 * @returns {String}
 **/
StoryVariables.storyArcAvailableVariable = function(storyArc) {
    return "storyarc" + storyArc.id + "_available";
};
/**
 * Get the variable name for a complete of a StoryArc
 * @param {StoryArc} storyArc
 * @returns {String}
 **/
StoryVariables.storyArcCompletedVariable = function(storyArc) {
    return "storyarc" + storyArc.id + "_completed";
};
/**
 * Get the variable name for the unlock time of a StoryNode
 * @param {StoryNode} storyNode
 * @returns {String}
 **/
StoryVariables.storyNodeUnlockedTimeVariable = function(storyNode) {
    return "storynode" + storyNode.id + "_unlockedTime";
};
/**
 * Get the variable name for the available time of a StoryNode
 * @param {StoryNode} storyNode
 * @returns {String}
 **/
StoryVariables.storyNodeAvailableTimeVariable = function(storyNode) {
    return "storynode" + storyNode.id + "_availableTime";
};
/**
 * Get the variable name for the complete time of a StoryNode
 * @param {StoryNode} storyNode
 * @returns {String}
 **/
StoryVariables.storyNodeCompletedTimeVariable = function(storyNode) {
    return "storynode" + storyNode.id + "_completedTime";
};
/**
 * Get the variable name for the unlock time of a StoryArc
 * @param {StoryArc} storyArc
 * @returns {String}
 **/
StoryVariables.storyArcUnlockedTimeVariable = function(storyArc) {
    return "storyarc" + storyArc.id + "_unlockedTime";
};
/**
 * Get the variable name for the available time of a StoryArc
 * @param {StoryArc} storyArc
 * @returns {String}
 **/
StoryVariables.storyArcAvailableTimeVariable = function(storyArc) {
    return "storyarc" + storyArc.id + "_availableTime";
};
/**
 * Get the variable name for the complete time of a StoryArc
 * @param {StoryArc} storyArc
 * @returns {String}
 **/
StoryVariables.storyArcCompletedTimeVariable = function(storyArc) {
    return "storyarc" + storyArc.id + "_completedTime";
};
/**
 * Get the condition string for an unlock of a StoryNode
 * @returns {String}
 **/
StoryVariables.currentTimeVariable = function() {
    return "currentTime";
};
/**
 * Name of the start of story time variable 
 * @returns {String} 
 **/
StoryVariables.storyStartTimeVariable = function() {
    return "storyStartTime";
};